import { Component } from "react";
import Input from "../ui/Input";
import Select from "../ui/Select";
import Option from "../ui/Select/Option";

import "./style.scss";

class AddCreditcardForm extends Component {
    render() {
        return (
            <>
                <div className="column add-credicard-form">
                    <div className="row">
                        <Input placeHolder="Name on Card" />
                        <Input placeHolder="Card Number" />
                    </div>
                    <div className="row lock">
                        <Select>
                            <Option value="1">Month</Option>
                        </Select>
                        <Select>
                            <Option value="1">Year</Option>
                        </Select>
                        <Input placeHolder="CVV" />
                    </div>
                    <div className="row">
                        <Input className="street" placeHolder="Street Address" />
                        <Input className="zip" placeHolder="Zip Code" />
                    </div>
                </div>
            </>
        )
    }
}
export default AddCreditcardForm;